import { createContext, useContext, useState, type ReactNode } from 'react';
import { useEngine, useReady } from './session';

/**
 * Sélecteur de territoire permanent (CDC §3, §18) : l'utilisateur multi-territoires bascule sans
 * changer de compte ; aucune vue ne mélange les territoires sans l'indiquer (« Tous les territoires »).
 */
interface TerritoryCtx {
  territoryId: string | null;
  setTerritoryId(id: string | null): void;
  choices: { id: string; code: string; name: string }[];
}
const Ctx = createContext<TerritoryCtx | null>(null);

export function TerritoryProvider({ children }: { children: ReactNode }) {
  const engine = useEngine();
  const { me } = useReady();
  const choices = engine
    .list('territory')
    .filter((t) => t.isActive && (me.permissions['dossier.read'] === 'all' || me.territoryIds.includes(t.id)))
    .sort((a, b) => a.sortOrder - b.sortOrder);
  const [territoryId, setState] = useState<string | null>(() => {
    try {
      return localStorage.getItem(`clim.territory.${me.user.id}`);
    } catch {
      return null;
    }
  });
  const setTerritoryId = (id: string | null) => {
    setState(id);
    try {
      if (id) localStorage.setItem(`clim.territory.${me.user.id}`, id);
      else localStorage.removeItem(`clim.territory.${me.user.id}`);
    } catch {
      /* ignore */
    }
  };
  const valid = territoryId && choices.some((c) => c.id === territoryId) ? territoryId : null;
  return <Ctx.Provider value={{ territoryId: valid, setTerritoryId, choices }}>{children}</Ctx.Provider>;
}

export function useTerritory() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('TerritoryProvider missing');
  return ctx;
}
